var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Row",
    { attrs: { gutter: 16 } },
    [
      _c(
        "Col",
        { attrs: { span: "24", label: "定金单列表", name: "depositType" } },
        [
          _c(
            "div",
            { staticClass: "global-tool-bar" },
            [
              _c("DepositOrderList", {
                ref: "depositOrderList",
                model: {
                  value: _vm.depositType,
                  callback: function ($$v) {
                    _vm.depositType = $$v
                  },
                  expression: "depositType",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }